"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const SidebarResult_vue_1 = __importDefault(require("@becrop/components/Results/Layout/SidebarResult.vue"));
const TopbarResult_vue_1 = __importDefault(require("@becrop/components/Results/Layout/TopbarResult.vue"));
const ProposalListYield_vue_1 = __importDefault(require("@becrop/components/Results/Projects/ProposalListYield.vue"));
const ProposalDetailYield_vue_1 = __importDefault(require("@becrop/components/Results/Projects/ProposalDetailYield.vue"));
const User_1 = __importDefault(require("@common/models/User"));
const ProposalsController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/ProposalsController"));
const SubclientsSwitcher_vue_1 = __importDefault(require("@becrop/components/Common/SubclientsSwitcher.vue"));
let ProjectsView = class ProjectsView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.raw_user = null;
        this.user = null;
        this.viewMode = 'list'; // 'list', 'detail', 'playground'
        this.proposalsService = new ProposalsController_1.default({
            itemsPerPageClient: 10,
            itemsPerPageServer: 50,
            totalItems: 0,
            currentPage: 1,
        });
        this.loadingData = false;
        this.loadingView = false;
        this.toastSubclient = false;
        this.statusParam = '';
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    async created() {
        // 1. Get user
        if (this.raw_user)
            this.user = User_1.default.fromJson(this.raw_user);
        if (this.raw_initial_proposals.page !== 0) {
            this.proposalsService.totalItems = this.raw_initial_proposals.total;
            this.proposalsService.currentPageProposals = {
                numPage: 0,
                proposals: [],
            };
        }
        const isSunclientChange = localStorage.getItem('is_subclient_change');
        const value = JSON.parse(isSunclientChange);
        if (value === true) {
            this.toastSubclient = true;
            await setTimeout(() => {
                this.toastSubclient = false;
            }, 10000);
            localStorage.setItem('is_subclient_change', JSON.stringify(false));
        }
    }
    is_visible_toast() {
        if (this.toastSubclient)
            return true;
        return false;
    }
    mounted() {
        this.onMountedList();
    }
    localStorageSubclient(subclientChange) {
        var _a;
        localStorage.setItem('is_subclient_change', JSON.stringify(true));
        localStorage.setItem('subclient_change', JSON.stringify((_a = subclientChange.sub_client) === null || _a === void 0 ? void 0 : _a.nombre_comercial));
    }
    get subclientChange() {
        const isSunclientChange = localStorage.getItem('subclient_change');
        return isSunclientChange;
    }
    async fetchDetails(id) {
        this.loadingData = true;
        await this.proposalsService.fetchDetails(id);
        this.loadingData = false;
    }
    async fetchProposalsFromServer(p, s) {
        this.loadingData = true;
        await this.proposalsService.fetchProposalsFromServer(p, s);
        this.loadingData = false;
    }
    async loadPageForced(n) {
        this.loadingData = true;
        await this.proposalsService.loadPageForced(n);
        this.loadingData = false;
    }
    async loadPage(n) {
        this.loadingData = true;
        await this.proposalsService.loadPage(n);
        this.loadingData = false;
    }
    async loadFilteredProposals(n, s) {
        this.loadingData = true;
        await this.proposalsService.loadFilteredProposals(n, s);
        this.loadingData = false;
    }
    async loadProposalDetail(id) {
        this.loadingView = true;
        await this.proposalsService.loadProposalDetail(id);
        this.loadingView = false;
        this.viewMode = 'detail';
    }
    async updateSortableProposals(c, d) {
        await this.proposalsService.updateSortableProposals(c, d);
    }
    async clearAllCachedProposals() {
        await this.proposalsService.clearAllCachedProposals();
    }
    launchCrumb(c) {
        if (c === 'home') {
            window.location.href = '/dashboard/';
        }
        const url = new URL(window.location.href.split('?')[0]);
        window.history.pushState({}, '', url);
        this.viewMode = c;
    }
    async onMountedList() {
        // 2a. If no params, fetch first batch
        if (this.raw_initial_proposals.page !== 0) {
            this.proposalsService.initializeProposals(this.raw_initial_proposals);
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('proposal')) {
                this.loadingView = true;
                await this.proposalsService.loadProposalDetail(parseInt(urlParams.get('proposal')));
                this.viewMode = 'detail';
                this.loadingView = false;
            }
        }
    }
    /*     async getURLParams() {
        const urlParams = new URLSearchParams(window.location.search);

        if(urlParams.get('proposal')) {
            await this.proposalsService.loadProposalDetail(parseInt(urlParams.get('proposal')))
            this.viewMode = 'detail';
        }
    } */
    dismissToas() {
        this.toastSubclient = false;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ProjectsView.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProjectsView.prototype, "raw_would_rather_crops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProjectsView.prototype, "raw_user", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: { numPage: 0, proposals: [] } })
], ProjectsView.prototype, "raw_initial_proposals", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProjectsView.prototype, "sidebar_selected", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProjectsView.prototype, "becrop_crops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProjectsView.prototype, "study_summary", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProjectsView.prototype, "study_options", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('toastSubclient')
], ProjectsView.prototype, "is_visible_toast", null);
ProjectsView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            StandardTemplate: bmk_ui_framework_1.StandardTemplate,
            SidebarResult: SidebarResult_vue_1.default,
            TopbarResult: TopbarResult_vue_1.default,
            ProposalListYield: ProposalListYield_vue_1.default,
            ProposalDetailYield: ProposalDetailYield_vue_1.default,
            SubclientsSwitcher: SubclientsSwitcher_vue_1.default,
            Toasts: bmk_ui_framework_1.Toasts,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
        },
    })
], ProjectsView);
exports.default = ProjectsView;
